import React from "react";
import configuration from "../../../utils/configuration";

const AuthHeader = () => {
  return <></>;
};

export default AuthHeader;
